import Divider from "../Divider";
import React from "react";
import ScheduleWidgetTable from "../ScheduleWidgetTable";
import Spacer from "../Spacer";

const ScheduleWidget = () => {
  return (
    <Spacer>
      <div className="p-6 bg-gray-100">
        <div className="mb-4 text-sm font-bold text-cream">Our Schedule</div>
        <Divider />
        <ScheduleWidgetTable />
      </div>
    </Spacer>
  );
};

export default ScheduleWidget;
